import React from "react";
import styles from "./side.module.scss";
import Discount from "../../../reusableComponent/discount/discount";
import Profile from "../../../reusableComponent/profile/profile";
import BasicTabs from "../../../reusableComponent/sideBar/tabs/tabs";
import SideBarOptions from "./sideBarOptions/sideBarOptions";
import { useCustomSideBarLogic } from "./hooks/useCustomSideBarLogic";
import MobileNavBar from "./components/MobileNavBar";
import SideBarFooter from "./components/SideBarFooter";
import NewSideBarContent from "./components/NewSideBarContent";
import DiscardChanges from "../../../reusableComponent/discardChanges/discardChanges";
import { Messages } from "../../../../constant/messages/toastMessages";

// Extend the Window interface to include $zoho
declare global {
  interface Window {
    $zoho?: any;
  }
}

function CustomSideBar(): JSX.Element {
  const {
    isDesktopSidebarExpand,
    isOpenMobileSidebar,
    setIsOpenMobileSidebar,
    navBarStyles,
    toggleSidebar,
    currentHistoryId,
    handleCopy,
    handleNav,
    handleMobNav,
    handleBook,
    discardOpen,
    handleDiscardConfirm,
    handleDiscardCancel,
    promoCode,
    showNewSideBar,
    userInfo,
    handleSelect,
    firstScreen,
    screen,
    setIsAdminChat,
    isProduction,
    showGetHelpOptions,
    setShowGetHelpOptions,
    handleSignIn,
    isMobile,
    setShowZoho,
    setLoginCreateAccountState,
    pathname,
    setCurrentHistoryId,
    isAdminChat,
  } = useCustomSideBarLogic();

  return (
    <div className={styles.mainContainer}>
      <DiscardChanges
        open={discardOpen}
        onClose={handleDiscardCancel}
        handleDiscard={handleDiscardConfirm}
        message={Messages["discard.changes"].message}
      />
      <div className={`${styles.container} ${isOpenMobileSidebar ? styles.open : ""}`}>
        {promoCode[0]?.description && isMobile && <Discount promoCodeDescription={promoCode[0]?.description} />}
        {isMobile && (
          <MobileNavBar
            navBarStyles={navBarStyles}
            toggleSidebar={toggleSidebar}
            isAdminChat={isAdminChat}
            userInfo={userInfo}
            pathname={pathname}
            currentHistoryId={currentHistoryId}
            handleCopy={handleCopy}
            handleBook={handleBook}
          />
        )}
        <div
          className={`${styles.sidebar} ${isOpenMobileSidebar ? styles.sidebarOpen : styles.sideBarClose} ${
            promoCode[0]?.description && styles.sidebarPromo
          }`}
          style={{
            width: isMobile ? (isOpenMobileSidebar ? "100%" : "0px") : "72px",
          }}
          onClick={(e) => {
            if (isMobile && isOpenMobileSidebar && e.target === e.currentTarget) {
              toggleSidebar();
            }
          }}
        >
          {showNewSideBar ? (
            <NewSideBarContent
              isMobile={isMobile}
              isDesktopSidebarExpand={isDesktopSidebarExpand}
              toggleSidebar={toggleSidebar}
              setIsOpenMobileSidebar={setIsOpenMobileSidebar}
              setIsAdminChat={setIsAdminChat}
              setCurrentHistoryId={setCurrentHistoryId}
              handleNav={handleNav}
              handleMobNav={handleMobNav}
              userInfo={userInfo}
              firstScreen={firstScreen}
              screen={screen}
              handleSelect={handleSelect}
            />
          ) : (
            <SideBarFooter
              userInfo={userInfo}
              isProduction={isProduction}
              showGetHelpOptions={showGetHelpOptions}
              setShowGetHelpOptions={setShowGetHelpOptions}
              toggleSidebar={toggleSidebar}
              handleSelect={handleSelect}
              handleSignIn={handleSignIn}
              setLoginCreateAccountState={setLoginCreateAccountState}
              setShowZoho={setShowZoho}
            >
              <Profile onClick={toggleSidebar} />
              <SideBarOptions onClick={toggleSidebar} />
              <BasicTabs setIsOpenMobileSidebar={setIsOpenMobileSidebar} isOpenMobileSidebar={isOpenMobileSidebar} />
            </SideBarFooter>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomSideBar;
